import { reduxStore } from './index';

export const initCurrentMove = () => ({
  type: 'INIT_CURRENT_MOVE',
});

export const currentMoveCreated = () =>
  new Promise(resolve => {
    const { currentMoveInit } = reduxStore().getState();
    if (!currentMoveInit) {
      const unsubscribe = reduxStore().subscribe(() => {
        const { currentMoveInit } = reduxStore().getState();
        if (currentMoveInit) {
          unsubscribe();
          resolve(reduxStore().getState());
        }
      });
    } else {
      resolve(reduxStore().getState());
    }
  });
